import React, { useReducer } from 'react';

const initialState = {
    fundRequest: null,
    expenseItemType: null,
    expenseItemId: null,
    uploadPath: null,
    uploads: [],
    pendingUploads: {},
    formKey: null,
    annualRates: null,
    glCodes: null,
};

export const FundRequestContext = React.createContext();

const FundRequestReducer = (state, action) => {
    switch (action.type) {
        case 'set_fund_request':
            return {
                ...state,
                fundRequest: action.payload,
            };

        case 'set_form_key':
            return {
                ...state,
                formKey: action.payload,
            };

        case 'reset_form_key':
            return {
                ...state,
                formKey: null,
            };

        case 'set_uploads':
            return {
                ...state,
                uploads: action.payload,
            };

        case 'add_pending_upload':
            return {
                ...state,
                pendingUploads: {
                    ...state.pendingUploads,
                    [action.payload.formKey]: [
                        ...(state.pendingUploads[action.payload.formKey] || []),
                        action.payload.file
                    ]
                }
            };

        case 'remove_pending_upload':
            return {
                ...state,
                pendingUploads: {
                    ...state.pendingUploads,
                    [action.payload.formKey]: (state.pendingUploads[action.payload.formKey] || [])
                        .filter((_, index) => index !== action.payload.index)
                }
            };

        case 'clear_pending_uploads':
            return {
                ...state,
                pendingUploads: action.payload ?
                    { ...state.pendingUploads, [action.payload]: [] } :
                    {}
            };

        case 'set_annual_rates':
            return {
                ...state,
                annualRates: action.payload,
            };

        case 'set_gl_codes':
            return {
                ...state,
                glCodes: action.payload,
            };

        case 'set_upload_path': {
            const { expenseItemType, expenseItemId } = action.payload;
            if (!state.fundRequest) {
                return state;
            }
            const { fundRequest } = state;
            const uploadPath = `/v2/fundrequests/${fundRequest.id}/expenseitems/${expenseItemType}/${expenseItemId}`;
            return {
                ...state,
                expenseItemType,
                expenseItemId,
                uploadPath,
            };
        }

        case 'reset_upload_path':
            console.log('reset_upload_path');
            return {
                ...state,
                expenseItemType: null,
                expenseItemId: null,
                uploadPath: null,
            };

        case 'reset_fund_request':
            return {
                ...state,
                fundRequest: null,
                uploadPath: null,
                expenseItemType: null,
                expenseItemId: null,
                formKey: null,
                pendingUploads: {},
            };

        default:
            return state;
    }
};

export const FundRequestContextProvider = (props) => {
    const [state, fundRequestDispatch] = useReducer(
        FundRequestReducer,
        initialState
    );

    return (
        <FundRequestContext.Provider value={{ ...state, fundRequestDispatch }}>
            {props.children}
        </FundRequestContext.Provider>
    );
};

export const useFundRequestContext = () => {
    const context = React.useContext(FundRequestContext);
    if (context === undefined) {
        throw new Error(
            'useFundRequestContext must be used within a FundRequestContextProvider'
        );
    }
    return context;
};
